// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Center, Space } from '@mantine/core';
import { i18n } from '@lingui/core';
import { IconFileDescription } from '@tabler/icons';
import { FC } from 'react';
import EmptyListState from '../../Molecules/EmptyListState';
import DocumentHeadActions from '../../Templates/Documents/DocumentHeadActions';
import { BookitupDocumentType } from '../../Types/BookitupDocument';

interface Props {
  emptyDocuments: boolean;
  documentType?: BookitupDocumentType;
}

const DocumentsNotFound: FC<Props> = ({ emptyDocuments, documentType }) => {
  const message = documentType
    ? i18n._(`documents.empty.${documentType.toLowerCase()}`)
    : 'Du hast noch keine Dokumente.';

  return (
    <EmptyListState
      icon={<IconFileDescription size={30} stroke={1.6} />}
      title={emptyDocuments ? 'Noch keine Dokumente' : 'Keine Dokumente gefunden'}
      maxWidth={640}
    >
      {emptyDocuments ? (
        <Center inline>
          {message}
          {documentType !== 'CONTRACT' && documentType !== 'QUESTIONNAIRE' && (
            <>
              {` Klicke auf`}
              <Space w={5} />
              <DocumentHeadActions />
              <Space w={2} />, um zu beginnen.
            </>
          )}
        </Center>
      ) : (
        <>
          Die Kombination der ausgewählten <b>Filter</b> erzielt keine Ergebnisse.
        </>
      )}
    </EmptyListState>
  );
};

export default DocumentsNotFound;
